/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InventoryStatus {
    VALID = 'valid',
    EXPIRED = 'expired',
    EXPIRE_IN_AWHILE = 'expireInAWhile',
}
